import { Injectable } from '@angular/core';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class SessionStateService {
  constructor(private windowService: WindowService) {}

  getJson<T>(key: string): T | null {
    const rawValue = this.windowService.getSessionStorage(key);

    if (!rawValue) {
      return null;
    }

    try {
      return JSON.parse(rawValue) as T;
    } catch {
      this.windowService.removeSessionStorage(key);
      return null;
    }
  }

  setJson(key: string, value: unknown): void {
    this.windowService.setSessionStorage(key, JSON.stringify(value));
  }

  remove(key: string): void {
    this.windowService.removeSessionStorage(key);
  }
}
